import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {isReCaptchaEnabled} from '../../utils/app-utils';

export default function useReCaptcha(withReCaptcha: boolean): () => Promise<string | null> {

  const {executeRecaptcha} = useGoogleReCaptcha();

  return (): Promise<string | null> =>
    withReCaptcha && isReCaptchaEnabled && executeRecaptcha ? executeRecaptcha() : Promise.resolve(null);
}